module.exports = __webpack_public_path__ + "static/img/cert-brand-1.5a023c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cert-brand-1.png
// module id = rXZX
// module chunks = 1